var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xiaoXi"},[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.nuberTime}},[_c('view')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }